import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { auth } from "../firebaseConfig";
import "../Register.css"; // Asegúrate de tener estilos

function Register() {
  const [cuit, setCUIT] = useState("");
  const [nom_o_razon, setnom_o_razon] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRePassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Al montar el componente Login
    document.body.className = "register-body";

    // Al desmontar (cuando vamos al portal)
    return () => {
      document.body.className = ""; // Limpiamos
    };
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
  
    if (password !== repassword) {
      alert("Las contraseñas no coinciden");
      return;
    }
  
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // ✅ Enviar verificación de correo
      await sendEmailVerification(user);
      alert("Registro exitoso. Por favor revisá tu correo para verificar tu cuenta.");
  
      // Enviar datos al servidor para registrarlos en Google Sheets
      const response = await fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cuit,
          nom_o_razon,
          email,
          password,
        }),
      });
  
      const data = await response.json();
      console.log("Respuesta del servidor:", data);
  
      if (response.ok) {
        alert("Registro exitoso");
        navigate("/");
      } else {
        alert("Error al guardar Registro");
      }
    } catch (error) {
      alert("Error al registrarse: " + error.message);
    }
  };  

  return (
    <div className="login-containerR">
      
      <div className="login-boxR">
      <img src="sinec_logo_sidebar.png" alt="Logo" className="logo" />
        
        <form onSubmit={handleRegister}>
        <h3>Nuevo Usuario</h3>
          {/* Primera fila con CUIT, Nombre/Razón Social y Correo */}
          <div className="form-row">
            <input
              type="text"
              placeholder="CUIT"
              value={cuit}
              onChange={(e) => setCUIT(e.target.value)}
              required
              class="register-input"
            />
            <input
              type="text"
              placeholder="Nombre o Razón Social"
              value={nom_o_razon}
              onChange={(e) => setnom_o_razon(e.target.value)}
              required
              class="register-input"
            />
            <input
              type="email"
              placeholder="Correo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              class="register-input"
            />
          </div>
  
          {/* Segunda fila con Contraseña y Confirmar Contraseña */}
          <div className="form-row">
            <input
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              class="register-input double-width"
            />
            <input
              type="password"
              placeholder="Reingrese Contraseña"
              value={repassword}
              onChange={(e) => setRePassword(e.target.value)}
              required
              class="register-input double-width"
            />
          </div>
  
          <button type="submit">Registrarse</button>
        </form>
        <button onClick={() => navigate("/")}>Volver al Login</button>
      </div>
    </div>
  );  
}

export default Register;
